import { QualificationModel, IQualification } from "@core/models";

export const candidateQualificationMock = [
  new QualificationModel({
    [IQualification.qualificationId]: 42,
    [IQualification.qualificationLabel]: "Barista",
    [IQualification.familyId]: 2,
    [IQualification.familyLabel]: "Salle/Bar",
  }),
  new QualificationModel({
    [IQualification.qualificationId]: 2,
    [IQualification.qualificationLabel]: "Serveur",
    [IQualification.familyId]: 2,
    [IQualification.familyLabel]: "Salle/Bar",
  }),
];
